// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1q6oM","right":"styles_right__2PcE7"};